<template>
  <div class="floating-hearts" aria-hidden="true">
    <span
      v-for="heart in hearts"
      :key="heart.id"
      class="floating-heart"
      :style="heart.style"
    >
      <svg viewBox="0 0 32 29.6" focusable="false">
        <path d="M23.6 0c-2.7 0-5.2 1.5-6.6 3.8C15.6 1.5 13.1 0 10.4 0 5.9 0 2.2 3.7 2.2 8.2c0 9.1 14.8 21.4 14.8 21.4S31.8 17.3 31.8 8.2C31.8 3.7 28.1 0 23.6 0Z" />
      </svg>
    </span>
  </div>
</template>

<script setup lang="ts">
const hearts = [
  { id: 1, style: '--x: 8%; --size: 10px; --delay: -1.5s; --duration: 12s; --drift: 52px; --opacity: 0.34; --hue: 342deg;' },
  { id: 2, style: '--x: 17%; --size: 14px; --delay: -8s; --duration: 16s; --drift: -38px; --opacity: 0.28; --hue: 356deg;' },
  { id: 3, style: '--x: 26%; --size: 9px; --delay: -5s; --duration: 13s; --drift: 42px; --opacity: 0.32; --hue: 330deg;' },
  { id: 4, style: '--x: 36%; --size: 12px; --delay: -11s; --duration: 18s; --drift: -56px; --opacity: 0.24; --hue: 348deg;' },
  { id: 5, style: '--x: 45%; --size: 8px; --delay: -3s; --duration: 14s; --drift: 30px; --opacity: 0.3; --hue: 338deg;' },
  { id: 6, style: '--x: 57%; --size: 15px; --delay: -14s; --duration: 20s; --drift: -48px; --opacity: 0.22; --hue: 352deg;' },
  { id: 7, style: '--x: 68%; --size: 11px; --delay: -6.5s; --duration: 15s; --drift: 46px; --opacity: 0.3; --hue: 334deg;' },
  { id: 8, style: '--x: 79%; --size: 13px; --delay: -10s; --duration: 17s; --drift: -34px; --opacity: 0.26; --hue: 358deg;' },
  { id: 9, style: '--x: 90%; --size: 9px; --delay: -4.5s; --duration: 13s; --drift: 34px; --opacity: 0.32; --hue: 346deg;' },
  { id: 10, style: '--x: 13%; --size: 7px; --delay: -13s; --duration: 19s; --drift: -28px; --opacity: 0.24; --hue: 332deg;' },
  { id: 11, style: '--x: 31%; --size: 16px; --delay: -7s; --duration: 21s; --drift: 64px; --opacity: 0.2; --hue: 350deg;' },
  { id: 12, style: '--x: 52%; --size: 10px; --delay: -16s; --duration: 16s; --drift: -30px; --opacity: 0.28; --hue: 340deg;' },
  { id: 13, style: '--x: 73%; --size: 8px; --delay: -2s; --duration: 12s; --drift: 36px; --opacity: 0.34; --hue: 354deg;' },
  { id: 14, style: '--x: 84%; --size: 17px; --delay: -12s; --duration: 22s; --drift: -58px; --opacity: 0.18; --hue: 336deg;' },
] as const
</script>

<style scoped>
.floating-hearts {
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  z-index: 0;
}

.floating-heart {
  animation: heartFloat var(--duration) linear infinite;
  animation-delay: var(--delay);
  bottom: -12vh;
  color: hsl(var(--hue) 92% 64%);
  filter: drop-shadow(0 8px 16px hsl(var(--hue) 92% 58% / 0.22));
  height: var(--size);
  left: var(--x);
  opacity: 0;
  position: absolute;
  transform: rotate(45deg);
  width: var(--size);
}

.floating-heart svg {
  display: block;
  fill: currentColor;
  height: 100%;
  overflow: visible;
  width: 100%;
}

@keyframes heartFloat {
  0% {
    opacity: 0;
    transform: translate3d(0, 0, 0) rotate(45deg) scale(0.72);
  }

  12% {
    opacity: var(--opacity);
  }

  72% {
    opacity: calc(var(--opacity) * 0.9);
  }

  100% {
    opacity: 0;
    transform: translate3d(var(--drift), -118vh, 0) rotate(45deg) scale(1.28);
  }
}

@media (prefers-reduced-motion: reduce) {
  .floating-hearts {
    display: none;
  }
}
</style>
